import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'
import { parseEntityId } from '../entity'
import moment from 'moment'
class MovimientosTerminal {
  getVentaAExportador (fechaDesde, fechaHasta = null, exportador = null, cereal) {
    const axios = getAxiosInstance()
    const clave = {
      clave: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        exportador: exportador,
        cereal: cereal
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`/consulta_venta_filtrada?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getVentasAExportadorActual () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_venta_listado')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  addVentaExportador (formValues) {
    const axios = getAxiosInstance()
    const hoy = new Date()
    const valores = {
      fecha: formValues.fechaVenta || moment(hoy).format('YYYY-MM-DD'),
      cereal: formValues.cerealVenta,
      cereal_variedad: formValues.cerealVariedad || 'UNDEF',
      exportador: parseEntityId(formValues.exportadorVenta),
      cantidad: formValues.cantidad
    }
    const promise = axios.post(`venta`, { valores: { ...valores } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  updateVentaExportador (formValues) {
    const axios = getAxiosInstance()
    const hoy = new Date()
    const valores = {
      fecha: formValues.fechaVenta || moment(hoy).format('YYYY-MM-DD'),
      cereal: formValues.cerealVenta,
      cereal_variedad: formValues.cerealVariedad || 'UNDEF',
      exportador: parseEntityId(formValues.exportadorVenta),
      cantidad: formValues.cantidad
    }
    const promise = axios.put(`venta`, { valores: { ...valores }, clave: { id: formValues.id } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  deleteVentaExportador (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`venta?r=` +
      `{"clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }
}

export default MovimientosTerminal
